import React, { useState, useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import AssignBrandToSellerList from './AssignBrandToSeller/AssignBrandToSellerList'
import BrandList from './Brand/BrandList'
import { setPageTitle } from '../redux/slice/pageTitleSlice'
import { useDispatch, useSelector } from 'react-redux'
import { allCrudNames, allPages, checkPageAccess } from '../../lib/AllPageNames'
import NotFound from '../NotFound/NotFound'
import { isInventoryModel } from '../../lib/AllStaticVariables'

const ManageBrand = () => {
  const [searchParams] = useSearchParams()
  const assignBrand = searchParams.get('assignBrand')
  const dispatch = useDispatch()
  const { pageAccess } = useSelector((state) => state.user)
  const [activeToggle, setActiveToggle] = useState(
    Number(assignBrand)
      ? 'assign-brand'
      : checkPageAccess(pageAccess, allPages?.Brand, allCrudNames?.read)
      ? 'brand'
      : checkPageAccess(
          pageAccess,
          allPages?.assignBrandToSeller,
          allCrudNames?.read
        )
      ? 'assign-brand'
      : ''
  )

  useEffect(() => {
    dispatch(setPageTitle('Manage Brand'))
  }, [])

  return checkPageAccess(
    pageAccess,
    [allPages?.Brand, allPages?.assignBrandToSeller],
    allCrudNames?.read
  ) ? (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            {checkPageAccess(
              pageAccess,
              allPages?.Brand,
              allCrudNames?.read
            ) && (
              <Link
                onClick={() => setActiveToggle('brand')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'brand' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Brand
                  <hr />
                </span>
              </Link>
            )}
            {checkPageAccess(
              pageAccess,
              allPages?.assignBrandToSeller,
              allCrudNames?.read
            ) &&
              !isInventoryModel && (
                <Link
                  onClick={() => setActiveToggle('assign-brand')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'assign-brand' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Assign Brand To Seller
                    <hr />
                  </span>
                </Link>
              )}
          </div>

          <div className='tab-content p-3'>
            {checkPageAccess(
              pageAccess,
              allPages?.Brand,
              allCrudNames?.read
            ) && (
              <div
                id='brand'
                className={`tab-pane fade ${
                  activeToggle === 'brand' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'brand' && <BrandList />}
              </div>
            )}
            {checkPageAccess(
              pageAccess,
              allPages?.assignBrandToSeller,
              allCrudNames?.read
            ) && (
              <div
                id='assign-brand'
                className={`tab-pane fade ${
                  activeToggle === 'assign-brand' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'assign-brand' && <AssignBrandToSellerList />}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default ManageBrand
